import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import t from '../../../../../../../../../../css/global.module.css';
import s from '../../navItemButton.module.css';
import SvgCompose from '../../../../../../../../../Svg/SvgCompose';
import LinkOrSpan from '../../../../../../../../../ObfuscationTools';


const NavItemTxt = ({ notifs, data, displayLink }) => {
  const linkContent = (
    <Fragment>
      <SvgCompose
        className={s.icon}
        iconUri={data.icon}
        activeUri={data.icon}
        active={false}
      />
      {notifs}
      { data.labels.large && data.labels.small ? (
        <>
          <span className={`${s.label} ${t['helper_hide-BelowDesktop']} ${t.nowrap} ${t.truncate}`} data-cs-mask={data.link === '/user' ? 'true' : null}>
            {data.labels.large}
          </span>
          <span className={`${s.label} ${t['helper_show-BelowDesktop']} ${t.nowrap}`}>
            {data.labels.small}
          </span>
        </>
      ) : (
        <span className={`${s.label} ${t.truncate} ${t.nowrap}`} data-cs-mask={data.link === '/user' ? 'true' : null}>{data.labels.default}</span>
      )}
    </Fragment>
  );


  return (
    <LinkOrSpan
      href={data.link}
      role="button"
      className={`${t['no-underline']} ${t['near-black']} ${s.item} ${t.pointer}`}
      displayLink={displayLink}
    >
      {linkContent}
    </LinkOrSpan>
  );
};

NavItemTxt.propTypes = {
  notifs: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  data: PropTypes.shape({
    link: PropTypes.string,
    icon: PropTypes.string,
    labels: PropTypes.shape({
      large: PropTypes.string,
      small: PropTypes.string,
      default: PropTypes.string,
    }),
  }).isRequired,
  displayLink: PropTypes.bool,
};

NavItemTxt.defaultProps = {
  notifs: null,
  displayLink: undefined,
};

export default NavItemTxt;
